import * as React from 'react';
import { Component } from 'react';
import * as _ from 'lodash';
import { get } from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';
import {
  createSidebar,
  toggleSidebarCollapse,
  updateSidebar,
} from '../../redux/actions/general/sidebar';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  dateFrom,
  dateTimeFrom,
  getActiveStage,
  getURLParam,
  guessPaperSize,
  hasURLParam,
  ptToMm,
  redirect,
  setURLParam,
  setTableParams,
  backendURL,
  openInNewTab,
} from '../../core/utils';
import Table from '../../components/Table';
import {
  downloadLastRevision,
  listCurrentSetPlans,
  readCurrentSetPlan,
  searchCurrentSetPlanTextOccurrences,
  searchPlanRevisionsTextOccurrences,
  togglePlanRevisionFavorite,
} from '../../redux/actions/table/current_set_plans';
import { listFolders, deleteFolder } from '../../redux/actions/table/folders';
import styles from '../../styles/views/plans/CurrentSetPlans.scss';
import ArrowDoubleRightSmallIcon from '../../assets/images/arrow-double-right-small-15x15.svg';
import DownloadIcon from '../../assets/images/download-15x15.svg';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import FolderClosedIcon from '../../assets/images/folder-closed-16x16.svg';
import FolderOpenedIcon from '../../assets/images/folder-opened-16x16.svg';
import CurrentSetPlansFlyout from '../../flyouts/current_set_plans/CurrentSetPlansFlyout';
import Tooltip from '../../components/Tooltip';
import TableNA from '../../components/TableNA';
import Avatar from '../../components/Avatar';
import Image from '../../components/Image';
import OpenInNewTabIcon from '../../assets/images/open-in-new-tab-16x16.svg';
import { setNotification } from '../../redux/actions/general/notification';
import { downloadFile } from '../../redux/actions/general/downloader';
import { searchPlanTextOccurrences } from '../../redux/actions/table/working_set_plans';
import TagIcon from '../../assets/images/tag-16x16.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';

const MAX_FOLDER_DEPTH = 3;

const mapStateToProps = (state) => {
  return {
    table: state.table['current_set_plans'],
    auth: state.auth,
    sidebar: state.general.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.current_set_plans/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
class CurrentSetPlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: undefined,
      folders: [],
    };
  }

  _getSidebarExpanded(path) {
    const expanded = _.get(this.props.sidebar, path + '.expanded');

    return _.isUndefined(expanded) ? true : expanded;
  }

  _buildFolderTreeItems(folders, path, level = 1) {
    return _.map(folders, (folder, folder_index) => ({
      title: folder.title,
      count: folder.count,
      icon: FolderClosedIcon,
      expandedIcon: FolderOpenedIcon,
      expanded: this._getSidebarExpanded(path + '.' + folder_index),
      onClick: () => this._setFolderFilter(this._getFolderIds(folder)),
      onArrowClick: !_.isEmpty(folder.children)
        ? () => toggleSidebarCollapse(path + '.' + folder_index)
        : undefined,
      active: () => {
        const active_folders = _.split(getURLParam('filter.folder'), '|');
        const folder_ids = this._getFolderIds(folder);

        return !_.isEmpty(_.intersection(active_folders, folder_ids));
      },
      checkbox: {
        status: () => {
          const active_folders = _.split(getURLParam('filter.folder'), '|');
          const folder_ids = this._getFolderIds(folder);
          const intersected = _.intersection(active_folders, folder_ids);

          if (_.isEmpty(getURLParam('filter.folder'))) {
            return 'unchecked';
          }

          if (_.isEmpty(intersected)) {
            return 'unchecked';
          }

          return _.size(intersected) == _.size(folder_ids)
            ? 'checked'
            : 'neutral';
        },
        onClick: () => this._toggleFolderFilter(folder),
      },
      menuAction: {
        id: 'folder_' + folder.id,
        tooltip: __('Actions'),
        items: [
          {
            title: __('Add sub-folder'),
            onClick: () => this._openCreateFolderModal(folder.id),
            disabled: level >= MAX_FOLDER_DEPTH,
          },
          {
            title: __('Rename'),
            onClick: () => this._openRenameFolderModal(folder),
          },
          {
            title: __('Delete'),
            onClick: () => this._deleteFolder(folder),
          },
        ],
      },
      items: this._buildFolderTreeItems(
        folder.children || [],
        path + '.' + folder_index + '.items',
        level + 1
      ),
    }));
  }

  _deleteFolder(folder) {
    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __('This folder and its sub-folders will be deleted.'),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteFolder(this.props.match.params.stage, folder.id).then(() => {
              hideAlertbox();
              this._removeFolderFromFilter(folder);
              this._reloadFolders();
              listCurrentSetPlans(this.props.match.params.stage);
              setNotification(__('Folder has been deleted.'));
            });
          },
        },
      ],
    });
  }

  _removeFolderFromFilter(folder) {
    const deleted_ids = _.map(
      [{ id: folder.id }, ...this._flattenFolders(folder.children || [])],
      (row) => _.toString(row.id)
    );

    const active_folders = _.split(getURLParam('filter.folder'), '|');
    const next = _.reject(active_folders, (id) => _.includes(deleted_ids, id));

    setURLParam('filter.folder', _.join(next, '|'));
  }

  _getFolderIds(folder) {
    return _.map(
      [{ id: folder.id }, ...this._flattenFolders(folder.children || [])],
      (row) => _.toString(row.id)
    );
  }

  _setFolderFilter(folder_ids) {
    setURLParam('filter.folder', _.join(_.uniq(folder_ids), '|'));
  }

  _toggleFolderFilter(folder) {
    const active_folders =
      getURLParam('filter.folder') == ''
        ? []
        : _.split(getURLParam('filter.folder'), '|');

    const folder_ids = this._getFolderIds(folder);
    const intersected = _.intersection(active_folders, folder_ids);
    let next = active_folders;

    if (_.size(intersected) == _.size(folder_ids)) {
      next = _.reject(active_folders, (row) => _.includes(folder_ids, row));
    } else {
      next = [...active_folders, ...folder_ids];
    }

    next = _.uniq(_.reject(next, (row) => row == 'n/a'));

    setURLParam('filter.folder', _.join(next, '|'));
  }

  _flattenFolders(folders = []) {
    return _.reduce(
      folders,
      (acc, row) => [
        ...acc,
        { id: row.id, title: row.title },
        ...this._flattenFolders(row.children || []),
      ],
      []
    );
  }

  _reloadFolders() {
    return listFolders(this.props.match.params.stage).then(({ response }) => {
      this.setState(
        {
          folders: response.data || [],
        },
        () => {
          const discipline_items = _.get(
            this.props.table.filters,
            'discipline.items',
            {}
          );

          const discipline_sidebar_items =
            this._buildDisciplinesSidebarItems(discipline_items);
          const sidebar_items = [
            {
              title: __('Disciplines'),
              small_caps: true,
              onClick: () => toggleSidebarCollapse('items.0.items.0'),
              expanded: this._getSidebarExpanded('items.0.items.0'),
              onArrowClick: () => toggleSidebarCollapse('items.0.items.0'),
              items: discipline_sidebar_items,
            },
          ];
          const folders_item_index = sidebar_items.length;

          sidebar_items.push({
            title: __('Folders'),
            small_caps: true,
            icon: FolderClosedIcon,
            expandedIcon: FolderOpenedIcon,
            onClick: () =>
              toggleSidebarCollapse('items.0.items.' + folders_item_index),
            expanded: this._getSidebarExpanded(
              'items.0.items.' + folders_item_index
            ),
            onArrowClick: () =>
              toggleSidebarCollapse('items.0.items.' + folders_item_index),
            addAction: {
              tooltip: __('Add folder'),
              onClick: () => this._openCreateFolderModal(),
            },
            items: this._buildFolderTreeItems(
              this.state.folders,
              'items.0.items.' + folders_item_index + '.items'
            ),
          });

          updateSidebar('items.0.items', sidebar_items);
        }
      );
    });
  }

  _openCreateFolderModal(parent_id = null) {
    setTableParams('current_set_plans', {
      create_folder_wizard: {
        parent_id,
      },
    });
  }

  _openRenameFolderModal(folder) {
    setTableParams('current_set_plans', {
      create_folder_wizard: {
        folder_id: folder.id,
        title: folder.title,
      },
    });
  }

  _openAttachFoldersWizard(plan_ids) {
    if (_.isEmpty(this.state.folders)) {
      setNotification({
        text: __('No folders available. Create a folder first.'),
        type: 'warning',
      });
      return;
    }

    setTableParams('current_set_plans', {
      attach_folders_wizard: {
        plan_ids,
        folders: this.state.folders,
      },
    });
  }

  _handleAttachPlansToFolder(plan_ids) {
    if (_.isEmpty(this.state.folders)) {
      setNotification({
        text: __('No folders available. Create a folder first.'),
        type: 'warning',
      });
      return;
    }

    this._openAttachFoldersWizard(plan_ids);
  }

  _buildDisciplinesSidebarItems(items = {}) {
    const all_ids = _.keys(items);

    return [
      {
        title: __('plans.current-set.all-disciplines'),
        onClick: () => setURLParam('filter.discipline', ''),
        active: () => {
          const active_disciplines = _.split(
            getURLParam('filter.discipline'),
            '|'
          );
          const intersected = _.intersection(active_disciplines, _.keys(items));

          return (
            _.isEmpty(getURLParam('filter.discipline')) ||
            _.size(intersected) == _.size(items)
          );
        },
        checkbox: {
          status: () => {
            const active_disciplines = _.split(
              getURLParam('filter.discipline'),
              '|'
            );
            const intersected = _.intersection(
              active_disciplines,
              _.keys(items)
            );

            if (_.isEmpty(getURLParam('filter.discipline'))) {
              return 'checked';
            }

            if (_.isEmpty(intersected)) {
              return 'unchecked';
            } else if (_.size(intersected) == _.size(items)) {
              return 'checked';
            } else {
              return 'neutral';
            }
          },
          onClick: () => {
            const active_disciplines = _.split(
              getURLParam('filter.discipline'),
              '|'
            );
            const intersected = _.intersection(
              active_disciplines,
              _.keys(items)
            );

            if (
              _.size(intersected) == _.size(items) ||
              _.isEmpty(getURLParam('filter.discipline'))
            ) {
              setURLParam('filter.discipline', 'n/a');
            } else {
              setURLParam('filter.discipline', '');
            }
          },
        },
      },
      ..._.map(items, (discipline, discipline_id) => ({
        title: discipline,
        onClick: () => setURLParam('filter.discipline', discipline_id),
        active: () => {
          const active_disciplines = _.split(
            getURLParam('filter.discipline'),
            '|'
          );

          return (
            _.isEmpty(getURLParam('filter.discipline')) ||
            _.includes(active_disciplines, discipline_id)
          );
        },
        checkbox: {
          status: () => {
            const active_disciplines = _.split(
              getURLParam('filter.discipline'),
              '|'
            );

            if (_.isEmpty(getURLParam('filter.discipline'))) {
              return 'checked';
            }

            return _.includes(active_disciplines, discipline_id)
              ? 'checked'
              : 'unchecked';
          },
          onClick: () => {
            const setDisciplines = (disciplines) => {
              disciplines = _.trim(
                _.join(
                  _.reject(disciplines, (discipline) => discipline == 'n/a'),
                  '|'
                ),
                '|'
              );

              setURLParam(
                'filter.discipline',
                _.isEmpty(disciplines) ? 'n/a' : disciplines
              );
            };

            const active_disciplines =
              getURLParam('filter.discipline') == ''
                ? all_ids
                : _.split(getURLParam('filter.discipline'), '|');

            if (_.includes(active_disciplines, discipline_id)) {
              setDisciplines(
                _.reject(active_disciplines, (row) => row == discipline_id)
              );
            } else {
              active_disciplines.push(discipline_id);
              setDisciplines(active_disciplines);
            }
          },
        },
      })),
    ];
  }

  _getPlanRow(plan_id) {
    return _.find(this.props.table.data, { id: plan_id });
  }

  _toggleFavourite(plan_revision_id, e) {
    e.stopPropagation();

    togglePlanRevisionFavorite(plan_revision_id).then(() => {
      listCurrentSetPlans(this.props.match.params.stage);
    });
  }

  _renderFavouriteButton(row, options = {}) {
    const { className = '', showEmpty = true, elementKey } = options;

    if (!row?.last_revision?.id) {
      return null;
    }

    const isFavourite = !!row.favourite;
    const icon = isFavourite ? '\u2605' : showEmpty ? '\u2606' : '';

    if (!icon) {
      return null;
    }

    return (
      <button
        key={elementKey}
        type='button'
        title={isFavourite ? 'Remove favourite' : 'Add favourite'}
        aria-label={isFavourite ? 'Remove favourite' : 'Add favourite'}
        className={classNames(
          styles.favouriteButton,
          isFavourite && styles.favouriteButtonActive,
          className
        )}
        onClick={(e) => this._toggleFavourite(row.last_revision.id, e)}
      >
        {icon}
      </button>
    );
  }

  componentDidMount() {
    enableProjectsDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/plans/current')
    );
    enableStagesDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/plans/current')
    );

    createSidebar({
      title: __('submenu.title.plans'),
      items: [
        {
          title: __('submenu.title.current-set'),
          link: () =>
            '/stages/' + getActiveStage() + '/plans/current?filter.discipline=',
          active: true,
        },
        {
          title: __('submenu.title.working-set'),
          link: () => '/stages/' + getActiveStage() + '/plans/working',
        },
        {
          title: __('submenu.title.uploads'),
          link: () => '/stages/' + getActiveStage() + '/plans/uploads',
        },
        {
          title: __('submenu.title.deliveries'),
          link: () => '/stages/' + getActiveStage() + '/deliveries',
        },
        {
          title: __('submenu.title.approvals'),
          link: () => '/stages/' + getActiveStage() + '/approvals',
        },
      ],
    });

    if (!hasURLParam('filter.discipline')) {
      setURLParam('filter.discipline', '');
    }
    if (!hasURLParam('filter.folder')) {
      setURLParam('filter.folder', '');
    }

    this._reloadFolders();

    setURLParam('filter.status', 1);
  }

  componentDidUpdate(prevProps) {
    //if there are new filter options available, update sidebar
    if (!_.isEqual(this.props.table.filters, prevProps.table.filters)) {
      const items = _.get(this.props.table.filters, 'discipline.items');

      const discipline_sidebar_items =
        this._buildDisciplinesSidebarItems(items);
      const sidebar_items = [
        {
          title: __('Disciplines'),
          small_caps: true,
          onClick: () => toggleSidebarCollapse('items.0.items.0'),
          expanded: this._getSidebarExpanded('items.0.items.0'),
          onArrowClick: () => toggleSidebarCollapse('items.0.items.0'),
          items: discipline_sidebar_items,
        },
      ];
      const folders_item_index = sidebar_items.length;

      sidebar_items.push({
        title: __('Folders'),
        small_caps: true,
        icon: FolderClosedIcon,
        expandedIcon: FolderOpenedIcon,
        onClick: () =>
          toggleSidebarCollapse('items.0.items.' + folders_item_index),
        expanded: this._getSidebarExpanded(
          'items.0.items.' + folders_item_index
        ),
        onArrowClick: () =>
          toggleSidebarCollapse('items.0.items.' + folders_item_index),
        addAction: {
          tooltip: __('Add folder'),
          onClick: () => this._openCreateFolderModal(),
        },
        items: this._buildFolderTreeItems(
          this.state.folders,
          'items.0.items.' + folders_item_index + '.items'
        ),
      });

      updateSidebar('items.0.items', sidebar_items);
    }

    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        this.setState({ preview: undefined });
      }

      readCurrentSetPlan(this.props.table.clicked_row).then(({ response }) => {
        this.setState({ preview: response.data });
      });
    }

    if (
      prevProps.table.create_folder_wizard &&
      !this.props.table.create_folder_wizard
    ) {
      this._reloadFolders();
    }

    if (
      this.props.table.folders_reload_at &&
      this.props.table.folders_reload_at !== prevProps.table.folders_reload_at
    ) {
      this._reloadFolders();
    }
  }

  _handleOpacity(value, row) {
    return row.status == '1' ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  render() {
    const columns = [
      {
        key: 'code',
        name: __('plans.table.title.code'),
        value: (value, row) => (
          <Tooltip text={value}>{this._handleOpacity(value, row)}</Tooltip>
        ),
        width: 90,
      },
      {
        key: 'thumb',
        name: __('plans.table.thumbnail'),
        value: (value, row) =>
          this._handleOpacity(
            row.thumbnail_url ? (
              <Tooltip
                placement='right'
                text={
                  <Image
                    className={styles.thumbPreview}
                    src={row.thumbnail_url}
                  />
                }
                html={true}
                dark={true}
              >
                <Image className={styles.thumb} src={row.thumbnail_url} />
              </Tooltip>
            ) : (
              <TableNA />
            ),
            row
          ),
        width: 50,
        sortable: false,
      },
      {
        key: 'title',
        name: __('plans.table.title.title'),
        required: true,
        value: (value, row) => this._handleOpacity(value, row),
        mobileVisible: true,
      },
      {
        key: 'delivery',
        name: __('plans.table.title.delivery'),
        value: (value, row) =>
          this._handleOpacity(
            <div
              className={styles.delivery}
              onClick={(e) => {
                e.stopPropagation();

                redirect(
                  '/stages/' +
                    this.props.match.params.stage +
                    '/deliveries/public/' +
                    row.last_revision.delivery.id
                );
              }}
            >
              {row.last_revision.delivery.title} <ArrowDoubleRightSmallIcon />
            </div>,
            row
          ),
        width: 150,
      },
      {
        key: 'discipline',
        name: __('plans.deliveries.columns.disciplines'),
        value: (discipline, row) => (
          <Tooltip
            text={[
              row.discipline.code,
              row.discipline.id == null
                ? row.discipline.description + '*'
                : _.get(this.props.localization.disciplines, [
                    row.discipline.id,
                    'name',
                  ]),
            ].join(': ')}
          >
            {this._handleOpacity(row.discipline.code, row)}
          </Tooltip>
        ),
        width: 60,
      },
      {
        key: 'team',
        name: __('plans.deliveries.columns.team'),
        value: (team, row) => (
          <Tooltip text={team.company}>
            {this._handleOpacity(team.company, row)}
          </Tooltip>
        ),
        width: 120,
      },
      {
        key: 'size',
        name: __('plans.table.title.size'),
        value: (size, row) =>
          row.width == 0 && row.height == 0 ? (
            <TableNA />
          ) : (
            <Tooltip
              text={
                guessPaperSize(ptToMm(row.width), ptToMm(row.height))
                  .description
              }
            >
              {this._handleOpacity(
                guessPaperSize(ptToMm(row.width), ptToMm(row.height)).size,
                row
              )}
            </Tooltip>
          ),
        width: 50,
      },
      {
        key: 'scale',
        name: __('plans.table.title.scale'),
        width: 50,
        fullWidth: true,
        value: (scale, row) =>
          this._handleOpacity(
            _.join([_.toNumber(row.scale1), _.toNumber(row.scale2)], ':'),
            row
          ),
      },
      {
        key: 'tiles_available',
        name: __('plans.table.title.tiles', {}, 'Tiles'),
        width: 100,
        sortable: false,
        value: (value, row) =>
          this._handleOpacity(
            value ? __('plans.tiles.available') : __('plans.tiles.removed'),
            row
          ),
      },
      {
        key: 'last_revision',
        name: __('plans.table.title.revision'),
        value: (value, row) => this._handleOpacity('R' + value.number, row),
        width: 50,
      },
      {
        key: 'created_at',
        name: __('plans.table.title.added'),
        default: true,
        desc: true,
        value: (value, row) => (
          <Tooltip text={dateTimeFrom(row.last_revision.created_at)}>
            {this._handleOpacity(dateFrom(row.last_revision.created_at), row)}
          </Tooltip>
        ),
        width: 80,
      },
      {
        key: 'created_by',
        name: __('plans.table.title.added-by'),
        value: (x, row) =>
          this._handleOpacity(
            <Avatar
              avatar_url={row.last_revision.created_by.avatar_url}
              name={row.last_revision.created_by.fullname}
              active={row.last_revision.created_by.active}
            />,
            row
          ),
        width: 50,
      },
      {
        key: 'properties',
        name: __('plans.table.title.properties'),
        width: 40,
        sortable: false,
        value: (value, row) => (
          <Tooltip text={__('plans.tooltip.icon.open-plan-properties')}>
            <InfoPositiveIcon
              onClick={(e) => {
                e.stopPropagation();
                this.props.actions.setTableParams({
                  clicked_row: row.id,
                  actioned_row: undefined,
                });
              }}
            />
          </Tooltip>
        ),
      },
    ];

    const groupActions = (attachment_ids) => [
      <Tooltip
        text={__('plans.tooltip.icon.documents.download-selected-plan')}
        key={_.uniqueId()}
      >
        <DownloadIcon
          onClick={(e) => {
            e.stopPropagation();

            setNotification(__('plan-revisions.files.download.continue'));

            downloadFile(
              backendURL + '/plans/revisions/download',
              { attachments: attachment_ids },
              'POST'
            );
          }}
        />
      </Tooltip>,
      <Tooltip text={__('Add selected plans to folders')} key={_.uniqueId()}>
        <FolderOpenedIcon
          onClick={(e) => {
            e.stopPropagation();
            this._handleAttachPlansToFolder(attachment_ids);
          }}
        />
      </Tooltip>,
    ];

    const singleActions = (plan_id) => [
      <Tooltip text={__('Open in new tab')} key={_.uniqueId()}>
        <OpenInNewTabIcon
          onClick={() => {
            openInNewTab(
              '/plans/revisions/' + this._getPlanRow(plan_id)?.last_revision?.id
            );
          }}
        />
      </Tooltip>,
      this.props.table.view != 'grid' &&
        this._renderFavouriteButton(this._getPlanRow(plan_id), {
          elementKey: `favourite-${plan_id}`,
        }),
      <Tooltip
        text={__('plans.tooltip.icon.current-set.plan-download')}
        key={_.uniqueId()}
      >
        <DownloadIcon
          onClick={(e) => {
            e.stopPropagation();

            downloadLastRevision(plan_id);
          }}
        />
      </Tooltip>,
    ];

    const tileStatus = (row) =>
      row.tiles_available
        ? __('plans.tiles.available')
        : __('plans.tiles.removed');

    const gridOptions = {
      section: 'Plans',
      image: (id, row) => row.thumbnail_url,
      title: (row) =>
        this._handleOpacity(
          row.code + (row.status == '0' ? ' (canceled)' : ''),
          row
        ),
      rightTitle: (row) => (
        <div className={styles.rightTitleWrapper}>
          {this._renderFavouriteButton(row, {
            className: styles.gridFavouriteButton,
          })}
          <span>{'R' + row.last_revision.number}</span>
        </div>
      ),
      subTitle: (row) => row.title,
      content: (row) => [
        dateFrom(row.last_revision.created_at) +
          ' by ' +
          row.last_revision.created_by.fullname,
        (row.width == 0 && row.height == 0
          ? ''
          : guessPaperSize(ptToMm(row.width), ptToMm(row.height)).size +
            ' (' +
            guessPaperSize(ptToMm(row.width), ptToMm(row.height)).description +
            ') | ') +
          _.join([_.toNumber(row.scale1), _.toNumber(row.scale2)], ':'),
        __('plans.table.title.tiles', {}, 'Tiles') + ': ' + tileStatus(row),
      ],
    };

    const preview = (
      <CurrentSetPlansFlyout
        data={_.get(this.state, 'preview', {})}
        readAction={(id) => {
          return new Promise((resolve) => {
            readCurrentSetPlan(getURLParam('id') || id).then(({ response }) => {
              this.setState({ preview: response.data });

              resolve(response);
            });
          });
        }}
      />
    );

    return (
      <Table
        listAction={() => listCurrentSetPlans(this.props.match.params.stage)}
        onRowClick={(id, row) =>
          redirect('/plans/revisions/' + row.last_revision.id)
        }
        name='current_set_plans'
        title={__('submenu.title.current-set')}
        columns={columns}
        preview={get(this.state, 'preview') ? preview : []}
        gridOptions={gridOptions}
        singleActions={singleActions}
        groupActions={groupActions}
        defaultView='grid'
        onLoad={() => listActiveModules()}
        initialSearchMode='dropdown'
        fetchSearchSuggestions={(query) =>
          searchPlanRevisionsTextOccurrences(
            this.props.match.params.stage,
            query
          )
        }
        onSuggestionClick={({ plan_revision_id }, query) =>
          redirect('/plans/revisions/' + plan_revision_id + '?query=' + query)
        }
      />
    );
  }
}

export default CurrentSetPlans;
